
























































































































































































































import { Component, Prop, Watch, Inject } from 'vue-property-decorator';
import Vue from "vue";
import { PublicClientApplication, AuthenticationResult, Configuration, AccountInfo } from '@azure/msal-browser';
import { UserInfo } from '../auth/AuthModule';

@Component({
	components: {
	}
})
export default class Navbar extends Vue {
	protected showVerticalNavbar: boolean = false;
	protected m_username: string;

	protected m_links: Link[] = [
		{
			text: "Продукти",
			to: "/products",
		},
		{
			text: "Поддръжка",
			to: "/support"
		},
		{
			text: "Контакти",
			to: "/contacts"
		},
		{
			text: "Софтуер",
			to: "/software",
			hidden: true
		},
	];

	protected get isLoggedIn(): boolean {
		return this.$store.getters.isLoggedIn;
	}

	protected get username(): string {
		return this.m_username;
	}

	protected get userProfile(): UserInfo {
		const acc = this.$store.getters.profile;
		return acc;
	}

	@Watch('isLoggedIn')
	protected onLoggedIn(value) {
		if (value)
			this.m_links.forEach(x => x.hidden = false);
	}

	protected get links(): Link[] {
		return this.m_links.filter(x => !x.hidden);
	}

	protected async onLogInClick(): Promise<void> {
		this.$auth.login();
	}

	protected async onLogOutClick(): Promise<void> {
		this.$auth.logout();
	}

	protected activeLink: Link = this.m_links[0];

	protected onLinkClick(link: Link): void {
		this.activeLink = link;
		this.showVerticalNavbar = false;
	}

	protected async mounted(): Promise<void> {

	}
}

interface Link {
	text: string;
	to: string;
	hidden?: boolean;
}
